window.HcProductForm = window.HcProductForm || {};

window.HcProductForm.init = (container) => {
  let section = container || null;
  let configScript = null;

  if (section) {
    configScript = section.querySelector('[data-hc-main-product-config]');
  } else {
    configScript = document.currentScript?.previousElementSibling || null;
    while (configScript && !configScript.matches('[data-hc-main-product-config]')) {
      configScript = configScript.previousElementSibling;
    }
    if (!configScript) {
      configScript = document.querySelector('quick-add-modal[open] [data-hc-main-product-config], .quick-add-modal__content-info [data-hc-main-product-config], .hc-product-main [data-hc-main-product-config]');
    }
    section = configScript ? configScript.closest('.quick-add-modal__content-info, .hc-product-main') : null;
  }
  if (!section || !configScript) return;
  if (section.dataset.hcFormInitialized === 'true') {
    const customizerAppSource = section.querySelector('[data-hc-customizer-app-source]');
    const customizerAppTarget = section.querySelector('[data-hc-customizer-app-target]');
    if (customizerAppSource && customizerAppTarget && customizerAppTarget.firstElementChild !== customizerAppSource) {
      customizerAppSource.hidden = false;
      customizerAppTarget.replaceChildren(customizerAppSource);
      section.dataset.amazonCustomizerMounted = 'true';
    }
    return;
  }
  section.dataset.hcFormInitialized = 'true';

  const readProductConfig = () => {
    try {
      return JSON.parse(configScript.textContent || '{}');
    } catch (error) {
      return {};
    }
  };
  const productConfig = readProductConfig();

  window.HcProductGallery?.init(section);

    const productForm = section.querySelector('.hc-product-form');
    const quantityInput = section.querySelector('[data-hc-quantity-input]');
    const minusButton = section.querySelector('[data-hc-quantity-minus]');
    const plusButton = section.querySelector('[data-hc-quantity-plus]');
    const stickyQuantityInput = section.querySelector('[data-hc-sticky-quantity-input]');
    const stickyMinusButton = section.querySelector('[data-hc-sticky-quantity-minus]');
    const stickyPlusButton = section.querySelector('[data-hc-sticky-quantity-plus]');
    const addButton = section.querySelector('[data-hc-add-to-cart]');
    const addButtonLabel = section.querySelector('[data-hc-add-label]');
    const addButtonPrice = section.querySelector('[data-hc-add-price]');
    const productError = section.querySelector('[data-hc-product-error]');
    const variantInput = productForm?.querySelector('input[name="id"]');
    const optionButtons = Array.from(section.querySelectorAll('[data-hc-option-button]'));
    const optionGroups = Array.from(section.querySelectorAll('[data-hc-option-group]'));
    const priceElement = section.querySelector('[data-hc-total-price]');
    const comparePriceElement = section.querySelector('[data-hc-compare-price]');
    const discountBadges = Array.from(section.querySelectorAll('[data-hc-discount-badge], [data-hc-media-discount-badge], [data-hc-sticky-discount-badge]'));
    const discountPercentElements = Array.from(section.querySelectorAll('[data-hc-discount-percent]'));
    const inventoryElement = section.querySelector('[data-hc-inventory]');
    const inventoryTextElement = section.querySelector('[data-hc-inventory-text]');
    const productVariants = Array.isArray(productConfig.productVariants) ? productConfig.productVariants : [];
    const moneyFormat = productConfig.moneyFormat || '';
    const currencyCode = productConfig.currencyCode || 'USD';
    const hasAmazonCustomizer = Boolean(productConfig.hasAmazonCustomizer);
    const hasCustomizer = Boolean(productConfig.hasCustomizer ?? hasAmazonCustomizer);
    const customizerProvider = productConfig.customizerProvider || (hasAmazonCustomizer ? 'amazon' : 'none');
    const requiresCustomization = Boolean(productConfig.requiresCustomization ?? hasAmazonCustomizer);
    const customizerConfigValid = productConfig.customizerConfigValid !== false;
    const i18n = productConfig.i18n || {};
    let syncQuantityValue = null;
    let selectedVariant = productVariants.find((variant) => String(variant.id) === variantInput?.value) || productVariants[0];
    const customizerAppSource = section.querySelector('[data-hc-customizer-app-source]');
    const customizerAppTarget = section.querySelector('[data-hc-customizer-app-target]');
    const customizerStatus = section.querySelector('[data-hc-customizer-status]');
    const customizerStatusText = section.querySelector('[data-hc-customizer-status-text]');
    const customizerRetry = section.querySelector('[data-hc-customizer-retry]');
    const buyWithShopButtons = Array.from(section.querySelectorAll('[data-hc-buy-with-shop]'));
    const promotionBox = section.querySelector('[data-hc-promotion]');
    const promotionTiers = Array.from(section.querySelectorAll('[data-hc-promotion-tier]'));
    const promoCopyButton = section.querySelector('[data-hc-promo-copy]');
    const promoStatus = section.querySelector('[data-hc-promo-status]');
    const promoCopyLabel = section.querySelector('[data-hc-copy-label]');
    let eligibleCartQuantity = 0;

    delete section.dataset.amazonCustomizerMounted;
    if (customizerAppSource && customizerAppTarget) {
      section.dataset.amazonCustomizerMounted = 'true';
      customizerAppSource.hidden = false;
      customizerAppTarget.replaceChildren(customizerAppSource);
    }

    const getCustomizerRoot = () => customizerAppTarget?.querySelector('[data-product-personalizer-root], [data-amzcustom-root]') || section.querySelector('[data-hc-customizer-app-source] [data-amzcustom-root]');
    const getCustomizerAction = () => getCustomizerRoot()?.querySelector('.amzcustom-open') || customizerAppTarget?.querySelector('.amzcustom-open') || section.querySelector('[data-hc-customizer-open]');
    const syncCustomizePrices = () => {
      const actions = section.querySelectorAll('[data-hc-customizer-open], [data-hc-customizer-app-target] .amzcustom-open');
      actions.forEach((action) => {
        let price = action.querySelector('[data-hc-customize-price]');
        if (!price) {
          price = document.createElement('span');
          price.className = 'hc-btn-add-to-cart__price';
          price.setAttribute('data-hc-customize-price', '');
          action.appendChild(price);
        }
        action.classList.add('hc-customize-with-price');
        price.hidden = !selectedVariant?.available;
        price.textContent = selectedVariant ? formatMoney(selectedVariant.price) : '';
      });
    };
    const setCustomizerStatus = (message = '', retry = false) => {
      if (!customizerStatus || !customizerStatusText) return;
      customizerStatus.hidden = !message;
      customizerStatusText.textContent = message;
      if (customizerRetry) customizerRetry.hidden = !retry;
    };
    const syncCustomizerContext = () => {
      syncCustomizePrices();
      if (!hasCustomizer) return;
      const root = getCustomizerRoot();
      if (!root) {
        if (requiresCustomization) setCustomizerStatus('Customization is temporarily unavailable.', true);
        return;
      }

      const productFormId = productForm?.getAttribute?.('id');
      if (productFormId) root.dataset.productFormId = productFormId;
      root.dataset.variantId = String(selectedVariant?.id || '');
      root.dataset.basePrice = String(Number(selectedVariant?.price || 0) / 100);
      root.dataset.available = selectedVariant?.available ? 'true' : 'false';
      root.dataset.quantity = String(quantityInput?.value || 1);
      const imageUrl = selectedVariant?.featured_image?.src || selectedVariant?.featured_media?.preview_image?.src || '';
      if (imageUrl) root.dataset.productImage = imageUrl;

      const action = getCustomizerAction();
      if (action) action.disabled = !customizerConfigValid || !selectedVariant?.available;
      const detail = {
        variantId: root.dataset.variantId,
        quantity: Number(root.dataset.quantity || 1),
        price: Number(root.dataset.basePrice || 0),
        image: root.dataset.productImage || '',
        available: root.dataset.available === 'true'
      };
      root.dispatchEvent(new CustomEvent('hc:product-context', { detail }));
      section.dispatchEvent(new CustomEvent('hc:customizer-context', { detail }));

      if (customizerProvider === 'etsy') {
        if (!customizerConfigValid) setCustomizerStatus('Customization is temporarily unavailable.', true);
        else if (root.dataset.personalizerReady === 'true') setCustomizerStatus();
        else if (requiresCustomization) setCustomizerStatus('Loading customization...');
      }
    };

    customizerAppTarget?.addEventListener('click', (event) => {
      const action = event.target.closest?.('.amzcustom-open, [data-hc-customizer-open]');
      if (!action) return;
      const root = getCustomizerRoot();
      if (!root) {
        const fallback = section.querySelector('[data-hc-customizer-app-source] .amzcustom-open')
          || document.body.querySelector('.amzcustom-root .amzcustom-open');
        if (fallback && fallback !== action) {
          event.preventDefault();
          fallback.click();
          return;
        }
      }

      if (root) {
        delete root.dataset.hcPurchaseIntent;
        root.dispatchEvent(new CustomEvent('hc:purchase-intent', {
          detail: { intent: 'cart', variantId: selectedVariant?.id || '' },
          bubbles: true
        }));
      }
    });

    section.addEventListener('click', (event) => {
      const fallbackBtn = event.target.closest?.('[data-hc-customizer-open]');
      if (!fallbackBtn) return;
      const realAction = section.querySelector('[data-hc-customizer-app-source] .amzcustom-open')
        || document.body.querySelector('.amzcustom-root .amzcustom-open');
      if (realAction && realAction !== fallbackBtn) {
        event.preventDefault();
        realAction.click();
      }
    });

    customizerRetry?.addEventListener('click', () => window.location.reload());
    section.addEventListener('etsy-personalizer:ready', () => {
      setCustomizerStatus();
      syncCustomizerContext();
    });
    if (customizerProvider === 'etsy' && requiresCustomization && customizerConfigValid) {
      window.setTimeout(() => {
        if (getCustomizerRoot()?.dataset.personalizerReady !== 'true') {
          setCustomizerStatus('Customization could not load. Please reload and try again.', true);
        }
      }, 8000);
    }

    const ensureAddToCartCartDrawer = async () => {
      let cartDrawer = document.querySelector('cart-drawer');

      if (
        cartDrawer
        && typeof window.__preaLoadCartDrawerScript === 'function'
        && (
          !customElements.get('cart-drawer')
          || typeof cartDrawer.getSectionsToRender !== 'function'
          || typeof cartDrawer.renderContents !== 'function'
          || typeof cartDrawer.open !== 'function'
        )
      ) {
        try {
          await window.__preaLoadCartDrawerScript();
          if (customElements.whenDefined && !customElements.get('cart-drawer')) {
            await Promise.race([
              customElements.whenDefined('cart-drawer'),
              new Promise((resolve) => window.setTimeout(resolve, 1500))
            ]);
          }
        } catch (error) {
          // If lazy loading fails, add-to-cart still continues and falls back gracefully.
        }
      }

      return document.querySelector('cart-drawer');
    };

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode
      }).format(Number(cents || 0) / 100);
    };

    const getDiscountPercent = (variant) => {
      if (!variant || !(variant.compare_at_price > variant.price)) return 0;
      return Math.max(1, Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price));
    };

    const inventoryByVariant = productConfig.inventoryByVariant || {};
    const inventoryThreshold = Number(productConfig.inventoryThreshold || 0);

    const syncInventoryStatus = (variant) => {
      if (!inventoryElement || !inventoryTextElement) return;

      const quantity = variant ? Number(inventoryByVariant[String(variant.id)]) : NaN;
      const showLowStock = inventoryThreshold > 0
        && Number.isFinite(quantity)
        && quantity > 0
        && quantity <= inventoryThreshold;

      inventoryElement.hidden = !showLowStock;
      if (showLowStock) {
        inventoryTextElement.textContent = String(i18n.lowStock || '').replace('[[qty]]', quantity);
      }
    };

    const syncDiscountBadges = (variant) => {
      const percent = getDiscountPercent(variant);
      const hasDiscount = percent > 0;

      discountBadges.forEach((badge) => {
        badge.hidden = !hasDiscount;
      });

      discountPercentElements.forEach((element) => {
        element.textContent = hasDiscount ? String(percent) : '';
      });
    };

    const isEligiblePromotionItem = (item) => {
      if (!item || item.gift_card === true) return false;
      const handle = String(item.handle || '').toLowerCase();
      const productType = String(item.product_type || '').toLowerCase();
      if (
        handle.includes('customization-fee')
        || handle.includes('personalization-fee')
        || handle.includes('amazon-customization-addon')
        || productType.includes('customization fee')
        || productType.includes('personalization fee')
      ) return false;

      const properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
      return !Object.keys(properties).some((key) => {
        const normalizedKey = String(key).toLowerCase();
        return normalizedKey === '_fee_component'
          || normalizedKey === '_customization_fee'
          || normalizedKey === '_is_customizer_fee'
          || normalizedKey === '_technical_line';
      });
    };

    const syncPromotionState = () => {
      if (!promotionBox) return;
      const selectedQuantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
      const projectedQuantity = eligibleCartQuantity + selectedQuantity;
      promotionBox.dataset.projectedQuantity = String(projectedQuantity);

      let activeTier = null;
      promotionTiers.forEach((tier) => {
        const minimum = Number(tier.dataset.minQuantity || 0);
        const qualified = projectedQuantity >= minimum;
        tier.classList.toggle('is-qualified', qualified);
        tier.classList.remove('is-active');
        tier.removeAttribute('aria-current');
        if (qualified && (!activeTier || minimum > Number(activeTier.dataset.minQuantity || 0))) {
          activeTier = tier;
        }
      });

      if (activeTier) {
        activeTier.classList.add('is-active');
        activeTier.setAttribute('aria-current', 'true');
      }
    };

    const refreshPromotionCartQuantity = async () => {
      if (!promotionBox) return;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Unable to load cart');
        const cart = await response.json();
        eligibleCartQuantity = Array.isArray(cart.items)
          ? cart.items.filter(isEligiblePromotionItem).reduce((total, item) => total + Number(item.quantity || 0), 0)
          : 0;
      } catch (error) {
        eligibleCartQuantity = 0;
      }
      syncPromotionState();
    };

    const copyPromoCode = async () => {
      const code = promoCopyButton?.dataset.promoCode?.trim();
      if (!code) return;
      let copied = false;

      try {
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
      }

      if (promoStatus) {
        promoStatus.textContent = copied ? `Code ${code} copied` : `Copy code: ${code}`;
        window.clearTimeout(promoStatus._hcClearTimer);
        promoStatus._hcClearTimer = window.setTimeout(() => { promoStatus.textContent = ''; }, 2500);
      }

      if (promoCopyLabel) {
        promoCopyLabel.textContent = copied ? 'Copied' : 'Try again';
        promoCopyButton?.classList.toggle('is-copied', copied);
        window.clearTimeout(promoCopyLabel._hcClearTimer);
        promoCopyLabel._hcClearTimer = window.setTimeout(() => {
          promoCopyLabel.textContent = 'Copy Code';
          promoCopyButton?.classList.remove('is-copied');
        }, 2200);
      }
    };

    promoCopyButton?.addEventListener('click', copyPromoCode);
    document.addEventListener('prea:cart-updated', refreshPromotionCartQuantity);
    window.addEventListener('pageshow', refreshPromotionCartQuantity);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refreshPromotionCartQuantity();
    });
    refreshPromotionCartQuantity();

    const getSelectedOptions = () => {
      const selectedOptionsByPosition = new Map();

      optionButtons.forEach((button) => {
        if (button.classList.contains('is-selected')) {
          selectedOptionsByPosition.set(Number(button.dataset.optionPosition), button.value);
        }
      });

      return Array.from(selectedOptionsByPosition.entries())
        .sort((first, second) => first[0] - second[0])
        .map((entry) => entry[1]);
    };

    const findSelectedVariant = () => {
      if (!optionButtons.length) return selectedVariant;
      const selectedOptions = getSelectedOptions();

      return productVariants.find((variant) => (
        variant.options.length === selectedOptions.length
        && variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
      ));
    };

    const findVariantByOptions = (options) => productVariants.find((variant) => (
      variant.options.length === options.length
      && variant.options.every((optionValue, index) => optionValue === options[index])
    ));

    const updateAddonOptionDisplay = () => {
      if (!optionGroups.length) return;

      const selectedOptions = getSelectedOptions();

      optionGroups.forEach((group) => {
        const optionPosition = Number(group.dataset.optionPosition);
        const optionIndex = optionPosition - 1;
        const selectedButton = group.querySelector('.hc-option-button.is-selected');
        const selectedLabel = group.querySelector('[data-hc-addon-selected]');
        const isAddonGroup = group.hasAttribute('data-hc-addon-group');

        if (selectedButton && selectedLabel) {
          selectedLabel.textContent = selectedButton.value;
        }

        const buttons = Array.from(group.querySelectorAll('[data-hc-option-button]'));
        const buttonVariants = buttons.map((button) => {
          const optionSet = selectedOptions.slice();
          optionSet[optionIndex] = button.value;
          return {
            button,
            variant: findVariantByOptions(optionSet)
          };
        });
        const baseButtonVariant = isAddonGroup
          ? buttonVariants.find((item) => item.button.value.toLowerCase() === 'no')?.variant
          : null;
        const selectedCombinationVariant = findVariantByOptions(selectedOptions);
        const validPrices = buttonVariants
          .map((item) => item.variant?.price)
          .filter((price) => Number.isFinite(price));
        const basePrice = baseButtonVariant?.price ?? (
          isAddonGroup
            ? (selectedCombinationVariant?.price ?? null)
            : (buttonVariants.find((item) => Number.isFinite(item.variant?.price))?.variant?.price
              ?? (validPrices.length ? validPrices[0] : null))
        );

        buttonVariants.forEach(({ button, variant }) => {
          const priceElement = button.querySelector('[data-hc-option-delta]');
          if (!priceElement) return;

          let delta = 0;
          if (variant && basePrice !== null && button.value.toLowerCase() !== 'no') {
            delta = Math.max(0, variant.price - basePrice);
          }
          priceElement.textContent = delta > 0 ? `+${formatMoney(delta)}` : '';
        });
      });
    };

    const syncAddButtonState = () => {
      const canAdd = Boolean(selectedVariant?.available);
      if (addButton) addButton.disabled = !canAdd;
      buyWithShopButtons.forEach((button) => { button.disabled = !canAdd; });
      if (addButton && addButtonLabel) {
        addButtonLabel.textContent = canAdd
          ? (i18n.addToCart || 'Add to cart')
          : (i18n.soldOut || 'Sold out');
      }
      if (addButtonPrice) addButtonPrice.hidden = !canAdd;
    };

    const updateVariantDisplay = () => {
      selectedVariant = findSelectedVariant();

      if (!selectedVariant) {
        if (variantInput) variantInput.value = '';
        if (addButton) addButton.disabled = true;
        buyWithShopButtons.forEach((button) => { button.disabled = true; });
        if (addButtonLabel) addButtonLabel.textContent = i18n.unavailable || 'Unavailable';
        if (addButtonPrice) addButtonPrice.hidden = true;
        syncDiscountBadges(null);
        syncInventoryStatus(null);
        updateAddonOptionDisplay();
        syncCustomizerContext();
        return;
      }

      if (variantInput) variantInput.value = selectedVariant.id;
      if (addButtonPrice) addButtonPrice.textContent = formatMoney(selectedVariant.price);

      if (priceElement) {
        priceElement.textContent = formatMoney(selectedVariant.price);
        priceElement.classList.toggle(
          'hc-price--sale',
          selectedVariant.compare_at_price > selectedVariant.price
        );
      }

      if (comparePriceElement) {
        const hasComparePrice = selectedVariant.compare_at_price > selectedVariant.price;
        comparePriceElement.hidden = !hasComparePrice;
        comparePriceElement.textContent = hasComparePrice ? formatMoney(selectedVariant.compare_at_price) : '';
      }

      syncDiscountBadges(selectedVariant);
      syncInventoryStatus(selectedVariant);

      updateAddonOptionDisplay();
      syncAddButtonState();
      syncCustomizerContext();
      section.dispatchEvent(new CustomEvent('hc:variant-change', { detail: { variant: selectedVariant } }));
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        optionButtons
          .filter((optionButton) => optionButton.dataset.optionPosition === button.dataset.optionPosition)
          .forEach((optionButton) => {
            const isSelected = optionButton === button;
            optionButton.classList.toggle('is-selected', isSelected);
            optionButton.setAttribute('aria-pressed', String(isSelected));
          });

        updateVariantDisplay();
      });
    });

    updateVariantDisplay();

    const addonTooltipTriggers = Array.from(section.querySelectorAll('[data-hc-addon-tooltip-trigger]'));
    if (addonTooltipTriggers.length && section.dataset.addonTooltipReady !== 'true') {
      section.dataset.addonTooltipReady = 'true';

      const closeAddonTooltips = (exceptTooltip = null) => {
        section.querySelectorAll('[data-hc-addon-tooltip].is-open').forEach((tooltip) => {
          if (tooltip === exceptTooltip) return;
          tooltip.classList.remove('is-open');
          tooltip.querySelector('[data-hc-addon-tooltip-trigger]')?.setAttribute('aria-expanded', 'false');
        });
      };

      addonTooltipTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const tooltip = trigger.closest('[data-hc-addon-tooltip]');
          if (!tooltip) return;

          const shouldOpen = !tooltip.classList.contains('is-open');
          closeAddonTooltips(tooltip);
          tooltip.classList.toggle('is-open', shouldOpen);
          trigger.setAttribute('aria-expanded', String(shouldOpen));
        });

        trigger.addEventListener('blur', () => {
          window.setTimeout(() => {
            const tooltip = trigger.closest('[data-hc-addon-tooltip]');
            if (!tooltip || tooltip.contains(document.activeElement)) return;
            tooltip.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          }, 80);
        });
      });

      document.addEventListener('click', (event) => {
        if (section.contains(event.target) && event.target.closest('[data-hc-addon-tooltip]')) return;
        closeAddonTooltips();
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeAddonTooltips();
      });
    }

    section.querySelectorAll('[data-hc-other-styles-grid]').forEach((grid) => {
      let hideScrollbarTimer;
      let isPointerDown = false;
      let isDragging = false;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let scrollStart = 0;
      let suppressClick = false;

      const showScrollbar = () => {
        grid.classList.add('is-scrollbar-active');
        window.clearTimeout(hideScrollbarTimer);
        hideScrollbarTimer = window.setTimeout(() => {
          if (!isDragging) grid.classList.remove('is-scrollbar-active');
        }, 900);
      };

      grid.addEventListener('scroll', showScrollbar, { passive: true });
      grid.addEventListener('wheel', showScrollbar, { passive: true });
      grid.addEventListener('touchstart', showScrollbar, { passive: true });

      grid.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isPointerDown = true;
        isDragging = false;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        scrollStart = grid.scrollLeft;
        showScrollbar();
      });

      grid.addEventListener('pointermove', (event) => {
        if (!isPointerDown) return;
        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;

        if (!isDragging) {
          if (Math.abs(deltaX) > 6 && Math.abs(deltaX) > Math.abs(deltaY)) {
            isDragging = true;
            grid.classList.add('is-dragging');
            grid.setPointerCapture?.(event.pointerId);
          } else {
            return;
          }
        }

        event.preventDefault();
        grid.scrollLeft = scrollStart - deltaX;
        showScrollbar();
      });

      const endDrag = (event) => {
        if (!isPointerDown) return;
        const didDrag = isDragging;
        isPointerDown = false;
        isDragging = false;
        grid.classList.remove('is-dragging');

        if (grid.hasPointerCapture?.(event.pointerId)) {
          grid.releasePointerCapture(event.pointerId);
        }

        if (didDrag) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 100);
        }

        showScrollbar();
      };

      grid.addEventListener('pointerup', endDrag);
      grid.addEventListener('pointercancel', endDrag);

      grid.addEventListener('click', (event) => {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
          return;
        }

        const card = event.target.closest('a[data-hc-other-style-card], a.hc-other-style-card');
        if (!card || !card.href) return;

        if (card.classList.contains('is-active')) {
          event.preventDefault();
          return;
        }

        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
          event.preventDefault();
          window.location.href = card.href;
        }
      });
    });

    window.HcProductCustomizer?.init(section, productForm, i18n);

    if (quantityInput && minusButton && plusButton) {
      const minimum = Number(quantityInput.min) || 1;
      const maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
      const step = Number(quantityInput.step) || 1;

      const normalizeQuantity = (value) => {
        const parsedValue = Number.parseInt(value, 10);
        const safeValue = Number.isFinite(parsedValue) ? parsedValue : minimum;
        const steppedValue = minimum + Math.round((safeValue - minimum) / step) * step;
        return Math.min(maximum, Math.max(minimum, steppedValue));
      };

      const updateQuantity = (value) => {
        const quantity = normalizeQuantity(value);
        quantityInput.value = quantity;
        if (stickyQuantityInput) stickyQuantityInput.value = quantity;
        minusButton.disabled = quantity <= minimum;
        plusButton.disabled = quantity >= maximum;
        if (stickyMinusButton) stickyMinusButton.disabled = quantity <= minimum;
        if (stickyPlusButton) stickyPlusButton.disabled = quantity >= maximum;
        syncCustomizerContext();
        syncPromotionState();
      };
      syncQuantityValue = updateQuantity;

      minusButton.addEventListener('click', () => updateQuantity(Number(quantityInput.value) - step));
      plusButton.addEventListener('click', () => updateQuantity(Number(quantityInput.value) + step));
      quantityInput.addEventListener('change', () => updateQuantity(quantityInput.value));
      quantityInput.addEventListener('blur', () => updateQuantity(quantityInput.value));
      stickyMinusButton?.addEventListener('click', () => updateQuantity(Number(quantityInput.value) - step));
      stickyPlusButton?.addEventListener('click', () => updateQuantity(Number(quantityInput.value) + step));
      stickyQuantityInput?.addEventListener('input', () => updateQuantity(stickyQuantityInput.value));
      stickyQuantityInput?.addEventListener('change', () => updateQuantity(stickyQuantityInput.value));
      stickyQuantityInput?.addEventListener('blur', () => updateQuantity(stickyQuantityInput.value));
      updateQuantity(quantityInput.value);

      if (productForm && addButton) {
        productForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (addButton.disabled || addButton.getAttribute('aria-busy') === 'true') return;
          updateVariantDisplay();
          if (!selectedVariant?.available) return;

          updateQuantity(quantityInput.value);

          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
          if (addButtonLabel) addButtonLabel.textContent = i18n.adding || 'Adding...';
          if (productError) {
            productError.hidden = true;
            productError.textContent = '';
          }

          try {
            const cartDrawer = await ensureAddToCartCartDrawer();
            const formData = new FormData(productForm);

            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              const sectionsToRender = cartDrawer.getSectionsToRender();
              formData.append('sections', sectionsToRender.map((item) => item.id).join(','));
              formData.append('sections_url', window.location.pathname);
              if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(addButton);
            }

            const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
            const requestUrl = cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;

            const response = await fetch(requestUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-HC-Internal': 'true'
              },
              body: formData
            });
            const cartState = await response.json();

            if (!response.ok || cartState.status) {
              throw new Error(cartState.description || cartState.message || i18n.addError || 'Unable to add this product to your cart.');
            }

            const quickAddModal = section.closest('quick-add-modal');
            if (quickAddModal && typeof quickAddModal.hide === 'function') {
              quickAddModal.hide(true);
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(cartState);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open(addButton);
            }
            document.dispatchEvent(new CustomEvent('prea:cart-updated'));
          } catch (error) {
            if (productError) {
              productError.textContent = error.message || i18n.addError || 'Unable to add this product to your cart.';
              productError.hidden = false;
            }
          } finally {
            addButton.removeAttribute('aria-busy');
            syncAddButtonState();
          }
        });
      }

      if (productForm && buyWithShopButtons.length) {
        buyWithShopButtons.forEach((button) => {
          button.addEventListener('click', async () => {
            if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
            updateVariantDisplay();
            if (!selectedVariant?.available) return;

            updateQuantity(quantityInput.value);
            const originalLabel = button.innerHTML;
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
            button.textContent = 'Redirecting to checkout...';

            if (productError) {
              productError.hidden = true;
              productError.textContent = '';
            }

            try {
              const formData = new FormData(productForm);
              const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
              const requestUrl = cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
              const response = await fetch(requestUrl, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'X-HC-Internal': 'true'
                },
                body: formData
              });
              const result = await response.json();
              if (!response.ok || result.status) {
                throw new Error(result.description || result.message || i18n.addError || 'Unable to start checkout.');
              }

              window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
            } catch (error) {
              button.innerHTML = originalLabel;
              button.removeAttribute('aria-busy');
              syncAddButtonState();
              if (productError) {
                productError.textContent = error.message || i18n.addError || 'Unable to start checkout.';
                productError.hidden = false;
              }
            }
          });
        });
      }
    }

    const sizeGuideModal = section.querySelector('[data-hc-size-guide-modal]');
    const sizeGuideOpeners = section.querySelectorAll('[data-hc-size-guide-open]');

    if (sizeGuideModal && sizeGuideOpeners.length && section.dataset.sizeGuideReady !== 'true') {
      const sizeGuideDialog = sizeGuideModal.querySelector('.hc-size-guide-modal__dialog');
      const sizeGuideCloseControls = sizeGuideModal.querySelectorAll('[data-hc-size-guide-close]');
      let sizeGuidePreviousFocus = null;
      let sizeGuidePreviousBodyOverflow = '';
      let sizeGuideCloseTimer = null;

      if (sizeGuideDialog) {
        section.dataset.sizeGuideReady = 'true';

        const hydrateSizeGuideImage = () => {
          const image = sizeGuideModal.querySelector('[data-hc-size-guide-image]');
          if (!image || image.dataset.hcLoaded === 'true') return;

          if (image.dataset.src) image.src = image.dataset.src;
          image.dataset.hcLoaded = 'true';
        };

        const openSizeGuide = () => {
          window.clearTimeout(sizeGuideCloseTimer);
          hydrateSizeGuideImage();
          sizeGuidePreviousFocus = document.activeElement;
          sizeGuidePreviousBodyOverflow = document.body.style.overflow;
          if (sizeGuideModal.parentElement !== document.body) {
            document.body.appendChild(sizeGuideModal);
          }
          sizeGuideModal.hidden = false;
          sizeGuideModal.classList.remove('is-closing');
          sizeGuideModal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';

          window.requestAnimationFrame(() => {
            sizeGuideModal.classList.add('is-open');
            sizeGuideDialog.focus({ preventScroll: true });
          });
        };

        const closeSizeGuide = () => {
          if (sizeGuideModal.hidden) return;

          window.clearTimeout(sizeGuideCloseTimer);
          sizeGuideModal.classList.remove('is-open');
          sizeGuideModal.classList.add('is-closing');
          sizeGuideModal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = sizeGuidePreviousBodyOverflow;

          sizeGuideCloseTimer = window.setTimeout(() => {
            sizeGuideModal.hidden = true;
            sizeGuideModal.classList.remove('is-closing');

            if (sizeGuidePreviousFocus instanceof HTMLElement) {
              sizeGuidePreviousFocus.focus({ preventScroll: true });
            }
          }, 270);
        };

        sizeGuideOpeners.forEach((opener) => opener.addEventListener('click', openSizeGuide));
        sizeGuideCloseControls.forEach((control) => control.addEventListener('click', closeSizeGuide));

        sizeGuideModal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeSizeGuide();
          }
        });
      }
    }
    window.HcStickyAtc?.init({
      section,
      addButton,
      addButtonLabel,
      priceElement,
      comparePriceElement,
      stickyQuantityInput,
      quantityInput,
      hasAmazonCustomizer,
      hasCustomizer,
      customizerProvider,
      requiresCustomization,
      customizerConfigValid,
      i18n,
      customizerAppTarget,
      getCustomizerAction,
      syncQuantityValue
    });
  };

  if (typeof document !== 'undefined') {
    window.HcProductForm.init();
  }





// Smooth-scroll from the review badge to the Judge.me review widget
if (!window.__hcScrollToReviewsInstalled) {
  window.__hcScrollToReviewsInstalled = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest && event.target.closest('[data-hc-scroll-to-reviews]');
    if (!trigger) return;

    const widget = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg');
    if (!widget) return;

    event.preventDefault();
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

// Global interceptor to detect external apps adding to cart
if (!window.__hcCartInterceptorInstalled) {
  window.__hcCartInterceptorInstalled = true;
  
  const triggerCartDrawer = async () => {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (
        cartDrawer
        && typeof window.__preaLoadCartDrawerScript === 'function'
        && (
          !customElements.get('cart-drawer')
          || typeof cartDrawer.getSectionsToRender !== 'function'
          || typeof cartDrawer.renderContents !== 'function'
          || typeof cartDrawer.open !== 'function'
        )
      ) {
        try {
          await window.__preaLoadCartDrawerScript();
          if (customElements.whenDefined && !customElements.get('cart-drawer')) {
            await Promise.race([
              customElements.whenDefined('cart-drawer'),
              new Promise((resolve) => window.setTimeout(resolve, 1500))
            ]);
          }
        } catch (error) {}
      }

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        const sections = cartDrawer.getSectionsToRender().map((s) => s.id).join(',');
        
        const formData = new FormData();
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        
        const res = await fetch((window.routes?.cart_update_url || '/cart/update') + '.js', {
           method: 'POST',
           body: formData
        });
        const cartState = await res.json();
        
        const quickAddModal = document.querySelector('quick-add-modal[open]');
        if (quickAddModal && typeof quickAddModal.hide === 'function') {
          quickAddModal.hide(true);
        }
        
        cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.renderContents === 'function') {
           cartDrawer.renderContents(cartState);
        }
        document.dispatchEvent(new CustomEvent('prea:cart-updated'));
      } else {
        window.location = window.routes?.cart_url || '/cart';
      }
    } catch (e) {
      window.location = window.routes?.cart_url || '/cart';
    }
  };

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
      const isInternal = args[1] && args[1].headers && args[1].headers['X-HC-Internal'];
      if (args[1] && args[1].method && args[1].method.toUpperCase() === 'POST' && response.ok && !isInternal) {
        setTimeout(triggerCartDrawer, 200);
      }
    }
    return response;
  };

  const originalXHR = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js')) && this.status >= 200 && this.status < 300) {
        setTimeout(triggerCartDrawer, 200);
      }
    });
    originalXHR.apply(this, arguments);
  };
}
